"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxFailureResultsWithData = void 0;
var HxActorId_1 = __importDefault(require("./HxActorId"));
var HxAddInFailureResults_1 = require("./HxAddInFailureResults");
var HxCreateAccountFailureResults_1 = require("./HxCreateAccountFailureResults");
var HxFetchCdnFilesFailureResults_1 = require("./HxFetchCdnFilesFailureResults");
var HxMockFailureResults_1 = require("./HxMockFailureResults");
var HxUpdateAccountCredentialsFailureResults_1 = require("./HxUpdateAccountCredentialsFailureResults");
var HxUpdateAccountFailureResults_1 = require("./HxUpdateAccountFailureResults");
var HxUserErrorDetails_1 = require("./HxUserErrorDetails");
var HxFailureResultsWithData = /** @class */ (function () {
    function HxFailureResultsWithData(actorCompletionState, tag, tagString, failureResults, errorDetails) {
        this.tag = tag;
        this.tagString = tagString;
        this.actorCompletionState = actorCompletionState;
        this.data = failureResults;
        this.userErrorDetails = errorDetails;
    }
    HxFailureResultsWithData.deserialize = function (actorId, values) {
        var i = 0;
        var actorCompletionState = values[i++];
        var tag = values[i++];
        var tagString = values[i++];
        switch (actorId) {
            case HxActorId_1.default.CreateAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateGoogleCcAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateGoogleImapAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateICloudCcAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateICloudImapAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateImapAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateImapCcAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateManagedOnPremCcAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateMsaAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateO365Account:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreatePopAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateSunriseAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateUnmanagedOnPremCcAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateYahooCcAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.CreateYahooImapAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxCreateAccountFailureResults_1.deserializeHxCreateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.FetchAddInMarketplaceUrl:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxAddInFailureResults_1.deserializeHxAddInFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.FetchAddIns:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxAddInFailureResults_1.deserializeHxAddInFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.FetchCdnFiles:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxFetchCdnFilesFailureResults_1.deserializeHxFetchCdnFilesFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.FetchCustomPropertiesOnAppointment:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxAddInFailureResults_1.deserializeHxAddInFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.FetchCustomPropertiesOnMessage:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxAddInFailureResults_1.deserializeHxAddInFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.InstallAddIn:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxAddInFailureResults_1.deserializeHxAddInFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.MockActionWithCustomFailureResults:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxMockFailureResults_1.deserializeHxMockFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.UpdateAccount:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxUpdateAccountFailureResults_1.deserializeHxUpdateAccountFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            case HxActorId_1.default.UpdateAccountCredentials:
                {
                    var customFailureResults = void 0;
                    if (values[i++]) {
                        var resultsBytes = values[i++];
                        customFailureResults = HxUpdateAccountCredentialsFailureResults_1.deserializeHxUpdateAccountCredentialsFailureResults(resultsBytes);
                    }
                    // UserErrorDetails
                    var userErrorDetails = void 0;
                    if (values[i++]) {
                        var userErrorBytes = values[i++];
                        userErrorDetails = HxUserErrorDetails_1.deserializeHxUserErrorDetails(userErrorBytes);
                    }
                    if (i != values.length) {
                        throw "Result values not parsed completely";
                    }
                    var failureResultsWithData = new HxFailureResultsWithData(actorCompletionState, tag, tagString, customFailureResults, userErrorDetails);
                    return failureResultsWithData;
                }
            default:
                break;
        }
        throw "Actor has no CustomFailureResults";
    };
    return HxFailureResultsWithData;
}());
exports.HxFailureResultsWithData = HxFailureResultsWithData;
exports.default = HxFailureResultsWithData;
